import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TablePagination } from '@mui/material';
import Actions from './Actions/Actions';
import ControlledTable from '../../../../../../shared/ui/ControlledTable/ControlledTable';
import { displayedCells, headCells } from '../constants/headCells';
import prepareRows from './utils/prepareRows';

function Table({ reportTasks, loginToFullName, count, rowsPerPage, page, onPageChange, onRowsPerPageChange, fetchData }) {
  const rows = useMemo(() => prepareRows(reportTasks, loginToFullName), [reportTasks, loginToFullName]);

  return (
    <>
      <ControlledTable
        rows={rows}
        headCells={headCells}
        displayedCells={displayedCells}
        countRowsPerPage={rowsPerPage}
        selected={[]}
        setSelected={() => {}}
        disableCheckbox
        renderCustomControls={({ reportTaskId }) => <Actions reportTaskId={reportTaskId} refreshData={fetchData} />}
      />

      <TablePagination
        rowsPerPageOptions={[5, 15, 30]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </>
  );
}

Table.propTypes = {
  reportTasks: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  loginToFullName: PropTypes.objectOf(PropTypes.string),
  count: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
};

Table.defaultProps = {
  loginToFullName: {},
};

export default Table;
